module.exports = {
	"appImage": "https://firebasestorage.googleapis.com/v0/b/universalapp-a272a.appspot.com/o/1524169367514.jpg?alt=media&token=876d8b2f-7968-4365-a87b-0b07c30eab74",
	"appLogo": "https://firebasestorage.googleapis.com/v0/b/tester-8e38d.appspot.com/o/1547909762580.jpg?alt=media&token=6ebe1963-2214-430b-8a08-d4707b406c42",
	"appNavLogo": "https://firebasestorage.googleapis.com/v0/b/tester-8e38d.appspot.com/o/1547909755800.jpg?alt=media&token=88654f56-e182-4347-a168-50752f35fafe",
	"appSplash": "https://firebasestorage.googleapis.com/v0/b/tester-8e38d.appspot.com/o/1547909722339.jpg?alt=media&token=69b5c168-2e2d-4c11-970b-d9f46255cbe0",
	"config": {
		"currency_format": "amount_with_comma_separator",
		"currency_value": "$",
		"date_format": "d-m-Y",
		"date_format_from": "Y-m-d",
		"distance_in": "km",
		"time_format": "H:I",
		"time_format_from": "h:i"
	},
	"design": {
		"category": {
			"textColor": "#ffffff"
		},
		"general": {
			"backgroundColor": "#ffffff",
			"backgroundImage": true,
			"buttonBorderColor": "#000000",
			"buttonColor": "#555454",
			"buttonText": "#ffffff",
			"coloring": "advanced",
			"detailsBackgroundGradient": [
				{
					"color": "#fefeff"
				},
				{
					"color": "#FEFEFE"
				}
			],
			"detailsBackgroundImage": false,
			"hideTabIconName": true,
			"isRTL": false,
			"layout": "side",
			"outbound": false,
			"rounded": true
		},
		"navBar": {
			"backgroundColor": "rgba(0,0,0,0.0)",
			"barStyle": "light-content",
			"borderColor": "rgba(0,0,0,0.0)",
			"detailsBackgroundColor": "#ffffff",
			"detailsTintColor": "#000000",
			"statusBarBackgroundColor": "#000000",
			"tintColor": "#ffffff"
		},
		"rows": {
			"arrowColor": "#000000",
			"backgroundColor": "#ffffff",
			"backgroundGradient": [
				{
					"color": "#fcf7fd"
				},
				{
					"color": "#ede4fa"
				}
			],
			"desciptionColor": "#444444",
			"imageRowColor": "rgba(0,0,0,0.5)",
			"imageRowFontSize": 18,
			"imageRowFontWeight": "normal",
			"separatorColor": "#eeeeee",
			"titleColorOnGrid": "#eeeeee",
			"titleColorOnRow": "#000000"
		},
		"sideMenu": {
			"activeBackgroundColor": "#eeeeee",
			"activeTintColor": "#773cc4",
			"backgroundColor": "#ffffff",
			"inactiveBackgroundColor": "rgba(0,0,0,0)",
			"inactiveTintColor": "#111111"
		}
	},
	"name": "xReactAppBuilder",
	"navigation": {
		"menus": [
			{
				"categorySetup": {
					"category_style": "grid2",
					"data_point": "eventsnc_collection",
					"fields": {
						"description": "description",
						"image": "image",
						"title": "title"
					}
				},
				"category_first": true,
				"detailsSetup": {
					"actionButton": "BUY TICKET",
					"actionButtonWhenActionDone": "TICKET BOUGHT",
					"cartCODAvailable": true,
					"cartCODText": "You will pay at the venue.",
					"cartIcons": [
						"ios-calendar-outline",
						"ios-person-outline",
						"ios-card-outline",
						"ios-list-box-outline"
					],
					"cartLabels": [
						"Event",
						"Register",
						"Payment",
						"Summary"
					],
					"cartPayPalAvailable": true,
					"collections": [
						"variants",
						"ingredients",
						"photos"
					],
					"descriptionTitle": "Description",
					"directionButton": "Get Directions",
					"fields": {
						"description": "description",
						"descriptionFunctions": ",",
						"direction": "eventLocation",
						"image": "image",
						"photos": "photos",
						"price": "price",
						"priceFunctions": "round,toCurrency~USD,prepend~Price: ",
						"shareLink": "url",
						"subPrice": "price",
						"subPriceFunctions": "multiply~{qty},round,toCurrency~USD,prepend~/per ticket.",
						"subtitle": "locationName",
						"subtitle2": "eventDateStart",
						"subtitle2Functions": "toReadableDate~MMMM Do YYYY HH:mm",
						"subtitle2Icon": "FeClock",
						"subtitle3": "eventDateEnd",
						"subtitle3Functions": "toReadableDate~MMMM Do YYYY HH:mm",
						"subtitle3Icon": "FeClock",
						"subtitleAction": "location",
						"subtitleActionFunction": "openGps",
						"subtitleFunctions": " ",
						"subtitleIcon": "FeMapPin",
						"title": "title",
						"titleFunctions": "trim:40",
						"video": "videolink"
					},
					"isDirectShopping": true,
					"isShopping": true,
					"photosTitle": "Photos",
					"shareButton": "Share the event",
					"showPhotos": true,
					"videoButton": "View Video"
				},
				"icon": "FeCalendar",
				"isRoot": true,
				"listStyle": "grid",
				"listingSetup": {
					"collection_key": "collection_event",
					"data_point": "eventsnc",
					"fields": {
						"actionButton": "BUY",
						"description": "description",
						"image": "image",
						"subtitle": "eventDateStart",
						"subtitleFunctions": "toReadableDate~dddd MMMM Do YYYY",
						"title": "title"
					},
					"listing_style": "list",
					"showCategoryFilter": true
				},
				"name": "Events"
			},
			{
				"categorySetup": {
					"category_style": "grid2",
					"data_point": "events_collection",
					"fields": {
						"description": "description",
						"image": "image",
						"title": "title"
					}
				},
				"category_first": true,
				"detailsSetup": {
					"callButton": "Call",
					"cartIcons": [
						"ios-calendar-outline",
						"ios-person-outline",
						"ios-card-outline",
						"ios-list-box-outline"
					],
					"cartLabels": [
						"Event",
						"Register",
						"Payment",
						"Summary"
					],
					"cartPayPalAvailable": true,
					"collections": [
						"variants",
						"ingredients",
						"photos"
					],
					"descriptionTitle": "Description",
					"fields": {
						"description": "description",
						"descriptionFunctions": ",",
						"direction": "",
						"image": "image",
						"phone": "phoneNumber",
						"photos": "photos",
						"price": "price",
						"priceFunctions": "round,toCurrency~USD,prepend~Price: ",
						"shareLink": "url",
						"subPrice": "price",
						"subPriceFunctions": "multiply~{qty},round,toCurrency~USD,prepend~/per ticket.",
						"subtitle": "locationName",
						"subtitle2": "eventDateStart",
						"subtitle2Functions": "toReadableDate~YYYY-MM-DD HH:mm",
						"subtitle2Icon": "ios-time-outline",
						"subtitle3": "eventDateEnd",
						"subtitle3Functions": "toReadableDate~YYYY-MM-DD HH:mm",
						"subtitle3Icon": "ios-timer-outline",
						"subtitleAction": "location",
						"subtitleActionFunction": "openGps",
						"subtitleFunctions": " ",
						"subtitleIcon": "ios-pin-outline",
						"title": "title",
						"titleFunctions": "trim:40",
						"video": "video"
					},
					"isDirectShopping": true,
					"isShopping": false,
					"photosTitle": "Photos",
					"shareButton": "Share the event",
					"showPhotos": true,
					"videoButton": "View Video"
				},
				"icon": "FeMapPin",
				"isRoot": false,
				"listStyle": "grid",
				"listingSetup": {
					"collection_key": "collection_event",
					"data_point": "venue",
					"fields": {
						"actionButton": "BUY",
						"description": "description",
						"image": "image",
						"subtitle": "",
						"subtitleFunctions": "",
						"title": "title"
					},
					"listing_style": "list"
				},
				"name": "Map",
				"sectionType": "map"
			},
			{
				"categorySetup": {
					"category_style": "grid2",
					"data_point": "events_collection",
					"fields": {
						"description": "description",
						"image": "image",
						"title": "title"
					}
				},
				"category_first": false,
				"detailsSetup": {
					"collections": [
						"photos"
					],
					"fields": {
						"photos": "photos"
					},
					"hideHeader": true,
					"photosTitle": "Photos",
					"photosVertical": true,
					"showPhotos": true
				},
				"icon": "FeImage",
				"isRoot": true,
				"listStyle": "grid",
				"listingSetup": {
					"collection_key": "collection_album",
					"data_point": "albums",
					"fields": {
						"actionButton": "BUY",
						"description": "description",
						"image": "image",
						"subtitle": "date",
						"subtitleFunctions": "toReadableDate~MMMM Do YYYY",
						"title": "title"
					},
					"listing_style": "list"
				},
				"name": "Gallery"
			},
			{
				"icon": "FeBell",
				"name": "Notifications",
				"sectionType": "notifications"
			},
			{
				"category_first": false,
				"icon": "FeClipboard",
				"isRoot": true,
				"listStyle": "grid",
				"name": "Orders",
				"sectionType": "orders"
			},
			{
				"category_image": "https://firebasestorage.googleapis.com/v0/b/universalapp-a272a.appspot.com/o/audience-band-celebration-196652.jpg?alt=media&token=d017e658-d7e5-4183-a162-300bb0aa9d36",
				"display_header_image": true,
				"icon": "FeUsers",
				"image": "https://firebasestorage.googleapis.com/v0/b/universalapp-a272a.appspot.com/o/audience-band-celebration-196652.jpg?alt=media&token=d017e658-d7e5-4183-a162-300bb0aa9d36",
				"listStyle": "grid",
				"name": "Social",
				"subMenus": [
					{
						"id": 1,
						"image": "https://firebasestorage.googleapis.com/v0/b/universalapp-a272a.appspot.com/o/InsignificonSC32-Instagram-New%20copy.jpg?alt=media&token=b69e510c-a9c1-4e3d-b3a5-5393a270a6cd",
						"link": "https://www.instagram.com/",
						"name": "@yourClubName"
					},
					{
						"id": "2",
						"image": "https://firebasestorage.googleapis.com/v0/b/universalapp-a272a.appspot.com/o/InsignificonSC32-Facebook%20copy.jpg?alt=media&token=4123c154-f9db-4187-8b40-724d1d153ab8",
						"link": "https://www.facebook.com/",
						"name": "fb.com/yourClubName"
					},
					{
						"id": "3",
						"image": "https://firebasestorage.googleapis.com/v0/b/universalapp-a272a.appspot.com/o/InsignificonSC32-YouTube%20copy.png?alt=media&token=c811d418-3b30-430f-924b-40b1c9d68ce0",
						"link": "https://www.youtube.com/",
						"name": "@yourClubName"
					},
					{
						"id": "4",
						"image": "https://firebasestorage.googleapis.com/v0/b/universalapp-a272a.appspot.com/o/InsignificonSC32-Twitter%20copy.png?alt=media&token=58497d70-f610-4849-a307-a3727771982a",
						"link": "https://twitter.com/",
						"name": "@yourClubName"
					}
				]
			},
			{
				"categorySetup": {
					"category_style": "list",
					"data_point": "radios_collection",
					"fields": {
						"description": "description",
						"image": "image",
						"title": "name"
					}
				},
				"category_first": false,
				"detailsSetup": {
					"collections": [
						"radios"
					],
					"fields": {
						"fb": "facebook",
						"img": "image",
						"song": "currentSong",
						"stationName": "name",
						"stitle": "currentArtist",
						"streamLink": "stream",
						"twitt": "twitter"
					},
					"hideHeader": true,
					"isHavingStream": true,
					"navButtonAction": "add-to-favorites",
					"navButtonActionDoneIcon": "MdFavorite",
					"navButtonIconActiveIcon": "MdFavoriteBorder",
					"showNavButton": true
				},
				"icon": "FeMic",
				"isRoot": true,
				"listStyle": "grid",
				"listingSetup": {
					"collection_key": "collection_radios",
					"data_point": "radios",
					"fields": {
						"actionButton": "",
						"description": "description",
						"image": "image",
						"subtitle": "currentSong",
						"title": "name"
					},
					"haveThumbnails": true,
					"listing_style": "list",
					"showCategoryFilter": true
				},
				"name": "Radio"
			},
			{
				"categorySetup": {
					"category_style": "grid1",
					"data_point": "products_collection",
					"fields": {
						"description": "description",
						"image": "image",
						"title": "title"
					}
				},
				"category_first": true,
				"detailsSetup": {
					"actionButton": "ADD TO CART",
					"actionButtonWhenActionDone": "PRODUCT ADDED",
					"collections": [
						"variants",
						"ingredients",
						"photos"
					],
					"descriptionTitle": "Description",
					"fields": {
						"description": "description",
						"descriptionFunctions": ",",
						"image": "image",
						"photos": "photos",
						"price": "price",
						"priceFunctions": "round,toCurrency~USD,prepend~Price: ",
						"shareLink": "link",
						"subPrice": "price",
						"subPriceFunctions": "multiply~{qty},round,toCurrency~USD,prepend~/per piece ,append~ for {qty} item/s.",
						"subtitle": "brand",
						"subtitleFunctions": "prepend~Brand: ",
						"title": "title",
						"titleFunctions": "trim:40",
						"video": "video"
					},
					"isShopping": true,
					"navButtonAction": "add-to-favorites",
					"navButtonActionDoneIcon": "MdFavorite",
					"navButtonIconActiveIcon": "MdFavoriteBorder",
					"photosTitle": "Product Images",
					"shareButton": "Share this recepie",
					"showNavButton": "true",
					"showPhotos": true,
					"videoButton": "View Video"
				},
				"icon": "FeHome",
				"isRoot": true,
				"listStyle": "grid1",
				"listingSetup": {
					"collection_key": "collection_product",
					"data_point": "products",
					"fields": {
						"actionButton": "BUY",
						"description": "description",
						"image": "image",
						"subtitle": "price",
						"subtitleFunctions": "roundOn,toCurrency~USD",
						"title": "title"
					},
					"listing_style": "list"
				},
				"name": "Shop"
			},
			{
				"categorySetup": {
					"category_style": "grid2",
					"data_point": "restaurant_collection",
					"fields": {
						"description": "description",
						"image": "image",
						"title": "title"
					}
				},
				"category_first": true,
				"detailsSetup": {
					"actionButton": "ADD TO CART",
					"actionButtonWhenActionDone": "PRODUCT ADDED",
					"cartCODAvailable": true,
					"collections": [
						"variants",
						"ingredients",
						"photos"
					],
					"descriptionTitle": "Description",
					"fields": {
						"description": "description",
						"descriptionFunctions": ",",
						"image": "image",
						"photos": "photos",
						"price": "price",
						"priceFunctions": "round,toCurrency~USD,prepend~Price: ",
						"shareLink": "link",
						"subPrice": "price",
						"subPriceFunctions": "multiply~{qty},round,toCurrency~USD,prepend~/per piece ,append~ for {qty} item/s.",
						"subtitle": "calories",
						"subtitleFunctions": "prepend~Calories: ,append~ kCal",
						"title": "title",
						"titleFunctions": "trim:40",
						"video": "video"
					},
					"isShopping": true,
					"photosTitle": "Product Images",
					"shareButton": "Share this recepie",
					"showPhotos": true,
					"videoButton": "View Video"
				},
				"icon": "FeMenu",
				"isRoot": true,
				"listStyle": "grid",
				"listingSetup": {
					"collection_key": "collection",
					"data_point": "restaurant",
					"fields": {
						"actionButton": "BUY",
						"description": "description",
						"image": "image",
						"subtitle": "price",
						"subtitleFunctions": "roundOn,toCurrency~USD",
						"title": "title"
					},
					"listing_style": "list"
				},
				"name": "menu"
			},
			{
				"categorySetup": {
					"category_style": "grid1",
					"data_point": "recipes_collection",
					"fields": {
						"description": "description",
						"image": "image",
						"title": "title"
					}
				},
				"category_first": false,
				"detailsSetup": {
					"actionButton": "ADD TO CART",
					"actionButtonWhenActionDone": "PRODUCT ADDED",
					"collections": [
						"variants",
						"ingredients",
						"photos"
					],
					"commentButton": "Comments",
					"descriptionTitle": "Directions",
					"fields": {
						"description": "description",
						"descriptionFunctions": ",",
						"image": "image",
						"photos": "photos",
						"price": "price",
						"priceFunctions": "round,toCurrency~USD,prepend~Price: ",
						"shareLink": "link",
						"subPrice": "price",
						"subPriceFunctions": "multiply~{qty},round,toCurrency~USD,prepend~/per piece ,append~ for {qty} item/s.",
						"subtitle": "timetoprepare",
						"subtitleFunctions": "prepend~Time to prepare: ,append~ for {for} persons.",
						"title": "title",
						"titleFunctions": "trim:40",
						"video": "videolink"
					},
					"isShopping": false,
					"photosTitle": "Product Images",
					"shareButton": "Share this recepie",
					"showPhotos": true,
					"videoButton": "View Video"
				},
				"expanded": true,
				"icon": "FeMenu",
				"isRoot": true,
				"listStyle": "list",
				"listingSetup": {
					"collection_key": "collection_recipe",
					"data_point": "recipes",
					"fields": {
						"actionButton": "BUY",
						"description": "description",
						"image": "image",
						"subtitle": "timetoprepare",
						"title": "title"
					},
					"listing_style": "list"
				},
				"name": "Recipes"
			},
			{
				"categorySetup": {
					"category_style": "grid2",
					"data_point": "restaurant_collection",
					"fields": {
						"description": "description",
						"image": "image",
						"title": "title"
					}
				},
				"category_first": true,
				"detailsSetup": {
					"actionButton": "ADD TO CART",
					"actionButtonWhenActionDone": "PRODUCT ADDED",
					"cartCODAvailable": true,
					"collections": [
						"variants",
						"ingredients",
						"photos"
					],
					"descriptionTitle": "Description",
					"fields": {
						"description": "description",
						"descriptionFunctions": ",",
						"image": "image",
						"photos": "photos",
						"price": "price",
						"priceFunctions": "round,toCurrency~USD,prepend~Price: ",
						"shareLink": "link",
						"subPrice": "price",
						"subPriceFunctions": "multiply~{qty},round,toCurrency~USD,prepend~/per piece ,append~ for {qty} item/s.",
						"subtitle": "calories",
						"subtitleFunctions": "prepend~Calories: ,append~ kCal",
						"title": "title",
						"titleFunctions": "trim:40",
						"video": "video"
					},
					"isShopping": true,
					"photosTitle": "Product Images",
					"shareButton": "Share this recepie",
					"showPhotos": true,
					"videoButton": "View Video"
				},
				"icon": "FeMenu",
				"isRoot": true,
				"listStyle": "grid",
				"listingSetup": {
					"collection_key": "collection",
					"data_point": "reataurants",
					"fields": {
						"actionButton": "BUY",
						"description": "description",
						"image": "image",
						"subtitle": "price",
						"subtitleFunctions": "roundOn,toCurrency~USD",
						"title": "title"
					},
					"listing_style": "list"
				},
				"name": "General",
				"sectionType": ""
			},
			{
				"CODAvailable": true,
				"PayPalAvailable": true,
				"icon": "FeShoppingCart",
				"name": "Cart",
				"type": "cart"
			},
			{
				"icon": "MdAccountBox",
				"name": "Profile",
				"sectionType": "profile"
			},
			{
				"icon": "MdSearch",
				"name": "Users",
				"sectionType": "listOfUsers"
			},
			{
				"icon": "FePocket",
				"name": "Scanner",
				"sectionType": "scanner"
			},
			{
				"icon": "FeMessageCircle",
				"name": "Chats",
				"sectionType": "chats"
			},
			{
				"icon": "FePlusCircle",
				"name": "Add Contact",
				"sectionType": "addContact"
			},
			{
				"html": "<img class='img-responsive' src='https://s3.amazonaws.com/tcdn.mobidonia.com/codecanyon/info/Screenshot+at+Mar+20+23-01-48.png' /> <br /><br /> <div class=\"col-md-12\">     <h4>Thanks for purchasing</h4>     <h4>App Platform - All in one React Native Universal Mobile App</h4> </div> <br /><br /> <div class=\"col-md-12\">     <div class=\"col-md-6\">         <h4>Why do I see this?</h4>         <p>Because you haven't setup the app to be pointed to your Firebase.</p>     </div>     <div class=\"col-md-6\">         <h4>How do I do that?</h4>         <p>In config.js, in the first lines, replace with your connection strings for Firebase. Follow the documentation steps.</p>     </div> </div>",
				"icon": "FeInfo",
				"name": "webview",
				"sectionType": "web",
				"url": "http://mobidonia.com",
				"webSource": "html"
			},
			{
				"category_image": "https://firebasestorage.googleapis.com/v0/b/universalapp-a272a.appspot.com/o/1530571286790.jpg?alt=media&token=053c18fe-63f5-4763-a05e-f8b7cd89e476",
				"display_header_image": true,
				"icon": "FeUser",
				"listStyle": "grid",
				"name": "folder",
				"subMenus": [
					{
						"html": "<img class='img-responsive' src='https://s3.amazonaws.com/tcdn.mobidonia.com/codecanyon/info/Screenshot+at+Mar+20+23-01-48.png' /> <br /><br /> <div class=\"col-md-12\">     <h4>Thanks for purchasing</h4>     <h4>App Platform - All in one React Native Universal Mobile App</h4> </div> <br /><br /> <div class=\"col-md-12\">     <div class=\"col-md-6\">         <h4>Why do I see this?</h4>         <p>Because you haven't setup the app to be pointed to your Firebase.</p>     </div>     <div class=\"col-md-6\">         <h4>How do I do that?</h4>         <p>In config.js, in the first lines, replace with your connection strings for Firebase. Follow the documentation steps.</p>     </div> </div>",
						"icon": "MdInfoOutline",
						"name": "About",
						"sectionType": "web",
						"url": "http://mobidonia.com",
						"webSource": "html"
					}
				]
			},
			{
				"categorySetup": {
					"category_style": "grid2",
					"data_point": "product_collection",
					"fields": {
						"description": "description",
						"image": "image",
						"title": "title"
					}
				},
				"category_first": false,
				"detailsSetup": {
					"actionButton": "ADD TO CART",
					"actionButtonWhenActionDone": "PRODUCT ADDED",
					"collections": [
						"variants",
						"ingredients",
						"photos"
					],
					"descriptionTitle": "Description",
					"fields": {
						"description": "description",
						"descriptionFunctions": ",",
						"image": "image",
						"photos": "photos",
						"price": "price",
						"priceFunctions": "round,toCurrency~USD,prepend~Price: ",
						"shareLink": "link",
						"subPrice": "price",
						"subPriceFunctions": "multiply~{qty},round,toCurrency~USD,prepend~/per piece ,append~ for {qty} item/s.",
						"subtitle": "brand",
						"subtitleFunctions": "prepend~Brand: ",
						"title": "title",
						"titleFunctions": "trim:40",
						"video": "video"
					},
					"isShopping": true,
					"navButtonAction": "add-to-favorites",
					"navButtonActionDoneIcon": "MdFavorite",
					"navButtonIconActiveIcon": "MdFavoriteBorder",
					"photosTitle": "Product Images",
					"shareButton": "Share this recepie",
					"showNavButton": "true",
					"showPhotos": true,
					"videoButton": "View Video"
				},
				"icon": "FeCheck",
				"isRoot": true,
				"listStyle": "grid",
				"listingSetup": {
					"data_point": "products",
					"fields": {
						"actionButton": "BUY",
						"description": "description",
						"image": "image",
						"subtitle": "price",
						"subtitleFunctions": "roundOn,toCurrency~USD",
						"title": "title"
					},
					"listing_style": "list"
				},
				"name": "Wish List",
				"sectionType": "wish-list"
			},
			{
				"categorySetup": {
					"category_style": "grid1",
					"data_point": "product_collection_shopify",
					"fields": {
						"description": "description",
						"image": "image",
						"title": "title"
					}
				},
				"category_first": true,
				"detailsSetup": {
					"actionButton": "ADD TO CART",
					"actionButtonWhenActionDone": "PRODUCT ADDED",
					"collections": [
						"variants",
						"ingredients",
						"photos"
					],
					"descriptionTitle": "Description",
					"fields": {
						"description": "description",
						"descriptionFunctions": ",",
						"image": "image",
						"photos": "photos",
						"price": "price",
						"priceFunctions": "round,toCurrency~USD,prepend~Price: ",
						"shareLink": "link",
						"subPrice": "price",
						"subPriceFunctions": "multiply~{qty},round,toCurrency~USD,prepend~/per peace ,append~ for {qty} item/s.",
						"subtitle": "vendor",
						"subtitleFunctions": "prepend~Vendor: ",
						"title": "title",
						"titleFunctions": "trim:40",
						"video": "video"
					},
					"isShopping": true,
					"navButtonAction": "add-to-favorites",
					"navButtonActionDoneIcon": "MdFavorite",
					"navButtonIconActiveIcon": "MdFavoriteBorder",
					"photosTitle": "Product Images",
					"shareButton": "Share this recepie",
					"showNavButton": "true",
					"showPhotos": true,
					"videoButton": "View Video"
				},
				"icon": "FeHome",
				"isRoot": true,
				"listStyle": "grid1",
				"listingSetup": {
					"collection_key": "collection_product",
					"data_point": "products_shopify",
					"fields": {
						"actionButton": "BUY",
						"description": "description",
						"image": "image",
						"subtitle": "price",
						"subtitleFunctions": "roundOn,toCurrency~USD",
						"title": "title"
					},
					"listing_style": "list"
				},
				"name": "Shopify"
			},
			{
				"categorySetup": {
					"category_style": "grid2",
					"data_point": "news_collection",
					"fields": {
						"description": "description",
						"image": "image",
						"title": "title"
					}
				},
				"category_first": false,
				"detailsSetup": {
					"cartIcons": [
						"ios-calendar-outline",
						"ios-person-outline",
						"ios-card-outline",
						"ios-list-box-outline"
					],
					"cartLabels": [
						"Event",
						"Register",
						"Payment",
						"Summary"
					],
					"cartPayPalAvailable": true,
					"collections": [
						"variants",
						"ingredients",
						"photos"
					],
					"descriptionTitle": "Description",
					"fields": {
						"description": "description",
						"descriptionFunctions": ",",
						"direction": "eventLocation",
						"price": "price",
						"priceFunctions": "round,toCurrency~USD,prepend~Price: ",
						"shareLink": "shareLink",
						"subPrice": "price",
						"subPriceFunctions": "multiply~{qty},round,toCurrency~USD,prepend~/per ticket.",
						"subtitle": "locationName",
						"subtitle2": "eventDateStart",
						"subtitle2Functions": "toReadableDate~YYYY-MM-DD HH:mm",
						"subtitle2Icon": "ios-time-outline",
						"subtitle3": "eventDateEnd",
						"subtitle3Functions": "toReadableDate~YYYY-MM-DD HH:mm",
						"subtitle3Icon": "ios-timer-outline",
						"subtitleAction": "location",
						"subtitleActionFunction": "openGps",
						"subtitleFunctions": " ",
						"subtitleIcon": "ios-pin-outline",
						"title": "title",
						"titleFunctions": "trim:40",
						"video": "video"
					},
					"isDirectShopping": true,
					"isShopping": false,
					"navButtonAction": "add-to-favorites",
					"navButtonActionDoneIcon": "MdFavorite",
					"navButtonIconActiveIcon": "MdFavoriteBorder",
					"photosTitle": "Photos",
					"shareButton": "Share this post",
					"showNavButton": true,
					"showPhotos": false,
					"videoButton": "View Video"
				},
				"icon": "FeBook",
				"isRoot": true,
				"listStyle": "grid",
				"listingSetup": {
					"collection_key": "collection_news",
					"data_point": "news",
					"fields": {
						"actionButton": "BUY",
						"description": "description",
						"image": "image",
						"subtitle": "date",
						"subtitleFunctions": "toReadableDate~YYYY-MM-DD HH:mm",
						"title": "title"
					},
					"hasFeatures": true,
					"listing_style": "list",
					"showCategoryFilter": false
				},
				"name": "News"
			}
		],
		"type": "side"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config/builder/components.json
// module id = 994
// module chunks = 0